import { Navigate } from "react-router";
import { useGetUserSessionQuery } from "../../../apis/UserSession.api";
import { PrimaryUserSession, UserSession } from "../../../types/models/UserSession";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const UserSessionScoped = () => {
    const {
        data,
    } = useGetUserSessionQuery(PrimaryUserSession.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/user-sessions/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default UserSessionScoped;
